// src/components/inbox/LoadFailed.jsx
import React from "react";
import { Button } from "../ui";
import { LOAD_FAILED, TRY_AGAIN } from "./inboxFormat";

// A list, thread or tab load that failed (R71): the server's message when it
// sent one, else "Couldn't load. Try again.", and a Try again control.
export default function LoadFailed({ message, onRetry }) {
  return (
    <div
      data-slot="inbox-load-failed"
      className="tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-p-4 tw-text-sm tw-text-danger"
      role="alert"
    >
      <span>{message || LOAD_FAILED}</span>
      <Button variant="quiet" size="sm" onClick={onRetry}>
        {TRY_AGAIN}
      </Button>
    </div>
  );
}
